import { render, staticRenderFns } from "./totalHourShimmer.vue?vue&type=template&id=5a052fc2&"
import script from "./totalHourShimmer.vue?vue&type=script&lang=js&"
export * from "./totalHourShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports